import React, { Fragment, memo, useContext, useEffect, useState } from "react";
import { AlertPopup, closeLayerFn, Container, openLayerFn, PeriodSetting } from "../../Layout";

import ICON_NOTHING from "../../../resources/images/icon/icon_weight_set_gray.png";
import { PostApi1403, PostApi1404, PostApi1405, PostApi1406, PostApi1409 } from "../../../modules/network/padoPost";
import { AppContext } from "../../../components/AppProvider";
import { ConfirmLayer } from "../../../components/UI/Dialog";
import { _O } from "../../../modules/utils";
import { reLogin } from "../../common/AutoLogin/AutoLogin";
import { maxLengthCheck } from "../../common/maxLengthCheck/maxLengthCheck";
import { userHabit } from "../../../modules/utils/UserHabit";

export default memo((props) => {
    const { userinfo, phonecfg, cfg, auth, dispatch } = useContext(AppContext);
    const [checkedSeqNo, setCheckedSeqNo] = useState('');

    const [periodType, setPeriodType] = useState(props.match.params.periodType);
    const [startDate, setStartDate] = useState(props.match.params.startDate && props.match.params.startDate);
    const [endDate, setEndDate] = useState(props.match.params.endDate && props.match.params.endDate);

    const [seqNo, setSeqNo] = useState();

    const [contentsList, setContentsList] = useState({});

    const [trgtValue, setTrgtValue] = useState({
        "wght":0,
        "vrtnType":"M"
    });

    const [memoData, setMemoData] = useState({
        "seqNo":"",
        "memo":""
    })

    // 다이얼로그 [[
    const [dialog, setDialog] = useState({
        title: '',
        msg: '',
    })

    const handleConfirm = () => {
        handleConfirmDialog('확인', '선택한 기록을 삭제 하겠습니까?', '')
    }


    const handleConfirmDialog = (title, msg) => {
        setDialog({
            title: title,
            msg: msg,
        })

        openLayerFn($(".confirm-layer"));
    }

    const handleCancelCB = () => {
        closeLayerFn($(".confirm-layer"));
    }

    const handleConfirmCB = () => {
        request1404();
        closeLayerFn($(".confirm-layer"));
    }

    const Bottom = (
        <Fragment>
            <div className="allcheck-setting-area">
                <a onClick={()=>unCheckedAll()}>
                    <i className="clear"></i>선택해제
                </a>
                <a onClick={()=>handleConfirm()} className="btn-check-delete">
                    <i className="dele"></i>선택삭제
                </a>
            </div>
            {/* <div className="under-fixarea-emptybox"></div> */}
        </Fragment>
    );

    const BottomNothing = (
        <Fragment>
            <div className="under-fix-btnarea">
				<a className="btn-inputok"><i></i>입력</a>
			</div>
        </Fragment>
    )

    // 전체 선택 기능 추가
    const checkedAll = () => {
        if($("#checkAll").prop("checked")) {
            $("input:checkbox").prop("checked", true);
        } else {
            $("input:checkbox").prop("checked", false);
        }

        settingSeqNo();
    }

    const unCheckedAll = () => {
        $("input:checkbox").prop("checked", false);
        settingSeqNo();
    }

    const settingSeqNo = () => {
        let checkArr = new Array();

        $("input[name=checkSeqNo]:checked").each(function() {
            checkArr.push($(this).val());
        });
        setCheckedSeqNo(checkArr);
    }

    const request1403 = (userinfo) => {
        PostApi1403(userinfo, cfg, phonecfg, periodType, startDate, endDate, 1, 100)
        .then(res => {
            if (res.resultMsg === 'SUCCESS') {
                setContentsList(res.result);
            } else if(res.resultMsg === 'LOGOUT') {
                // openAlertPopup("다른 기기에 로그인 되어있습니다.");
                openLayerFn($('.alert-layer-logout'));
            } else {
                console.log("### ERR");
            }
        })
        .catch(err => {
            console.log(err);
        });
    }

    const request1404 = () => {
        PostApi1404(userinfo, cfg, phonecfg, checkedSeqNo)
        .then(res => {
            if(res.resultMsg === 'SUCCESS') {
                $("input:checkbox").prop("checked", false);
                request1403(userinfo);
                settingSeqNo();
            } else if(res.resultMsg === 'LOGOUT') {
                // openAlertPopup("다른 기기에 로그인 되어있습니다.");
                openLayerFn($('.alert-layer-logout'));
            } else {
                openAlertPopup("삭제실패");
            }
        })
        .catch(err => {
            console.log(err);
        });
    }

    const request1406 = (userinfo) => {
        PostApi1406(userinfo, cfg, phonecfg)
        .then(res => {
            if (res.resultMsg === 'SUCCESS') {
                // setTrgtWght(res.result.trgtWght);
                trgtValueHandler(res.result.trgtWght, res.result.vrtnType);

                if(res.result.trgtWght === "9999") {
                    $("#trgtWght").val("미등록");
                } else {
                    $("#trgtWght").val(res.result.trgtWght);
                }

                if(res.result.vrtnType == "P") {
                    $("#vrtnType").prop("checked", true);
                } else {
                    $("#vrtnType").prop("checked", false);
                }
            } else if(res.resultMsg === 'LOGOUT') {
                // openAlertPopup("다른 기기에 로그인 되어있습니다.");
                openLayerFn($('.alert-layer-logout'));
            } else {
                trgtValueHandler("미등록", res.result.vrtnType);
            }
        })
        .catch(err => {
            console.log(err);
        });
    }

    const trgtValueHandler = (wght, vrtnType) => {
        setTrgtValue({
            "wght":wght,
            "vrtnType":vrtnType
        });
    }

    const setMemoTrgt = (seqNo, memo) => {
        setMemoData({
            "seqNo":seqNo,
            "memo":memo
        });
        $("#bmiMemoTxt").val(memo);
        openLayerFn($(".memo-layer"));
        userHabit(phonecfg, "BM100_P02");
    }

    useEffect(() => {
        if(checkedSeqNo == "") {
            $(".allcheck-setting-area").hide();
        } else {
            $(".allcheck-setting-area").show();
        }
    }, [checkedSeqNo]);

    let userinfo2 = reLogin(auth, userinfo, dispatch);
    
    useEffect(() => {
        if(userinfo.userToken) {
            request1406(userinfo);
            request1403(userinfo);
        } else {
            request1406(userinfo2);
            request1403(userinfo2);
        }
    }, [periodType, startDate, endDate]);

    return(
        <Fragment>
            <Container Title='몸무게 목록' bottom={Bottom} goToUrl={"/sm/bmi/history" + '/' + periodType + '/' + startDate + '/' + endDate}>
                <div className="contents sub">

                    {/* 목표몸무게 */}
                    <div className="bloodgoal-input-area">
                        <div className="bloodgoal-round">
                            <span>목표몸무게</span>
                            <div className="inp-with-btn">

                                {/* <p className="nothing">미설정</p>  */}
                                <p>{trgtValue.wght === "9999" ? "미등록" : trgtValue.wght} <em>kg</em></p>

                                {/* 목표몸무게 설정팝업 */}
                                <a className="btn-goalset"></a>
                            </div>
                        </div>
                    </div>

                    <div className="sub-contents">
                        {contentsList && contentsList.length > 0 
                            ?  <Contents 
                                    resList={contentsList} setPeriodType={setPeriodType} periodType={periodType} 
                                    startDate={startDate} setStartDate={setStartDate} endDate={endDate} 
                                    setEndDate={setEndDate} setCheckedSeqNo={setCheckedSeqNo} checkedAll={checkedAll} 
                                    settingSeqNo={settingSeqNo} setMemoTrgt={setMemoTrgt}
                                />
                            :   <Nothing />
                        }
                    </div>
                </div>
            </Container>
            <TargetWeight trgtValue={trgtValue} trgtValueHandler={trgtValueHandler} />
            <MemoLayer memoData={memoData} request1403={request1403} />
            <ConfirmLayer
                priv="priv"
                title={dialog.title}
                msg={dialog.msg}
                handleCancelCB={handleCancelCB}
                handleConfirmCB={handleConfirmCB}
            />
            <AlertPopup />
        </Fragment>
    );
})

const Contents = (props) => {
    const { resList, setPeriodType, periodType, startDate, setStartDate, endDate, setEndDate, setCheckedSeqNo, checkedAll, settingSeqNo, setMemoTrgt} = props;

    return(
        <Fragment>
            <div className="date-setting-area">
                <PeriodSetting settingPeriodType={setPeriodType} periodType={periodType} startDate={startDate} setStartDate={setStartDate} endData={endDate} setEndDate={setEndDate}/>  
            </div>

            {/* <!-- 전체선택 / 색상 구분 --> */}
            <div className="allselect-box">
                <div className="dots-list">
                    <ul>
                        <li><i className="c1"></i> 정상이하</li>
                        <li><i className="c2"></i> 안정</li>
                        <li><i className="c3"></i> 과체중</li><br/>
                        <li><i className="c4"></i> 비만</li>
                        <li><i className="c5"></i> 고도비만</li>
                    </ul>
                </div>
                <div className="check-dotguide">
                    <label className="check-box">
                        <input type="checkbox" id="checkAll" onClick={()=>checkedAll()} /><i></i>전체선택
                    </label>
                </div>
                <p>
                    BMI 상태는 의사와 상담 후 입력한 목표 BMI 수치를 기준으로 판단합니다.
                    (목표몸무게 미 설정시 정상기준 : 20~25)
                </p>
            </div>

            <div>
                <div className="section-box">
                    <div className="time-schedule-list mh wmore">
                        {resList.map((m,i) => (
                            <ListItem settingSeqNo={settingSeqNo} setMemoTrgt={setMemoTrgt} data={m} i={i} key={i} />
                        ))}
                    </div>

                </div>
            </div>
        </Fragment>
    );
}

const Nothing = () => {
    return(
        <div className="nothing-box">
            <div>
                <img src={ICON_NOTHING} alt="" />
                <p>
                    입력한 정보가 없습니다.<br/>
                    몸무게를 입력해 주세요.
                </p>
            </div>
        </div>
    );
}

export const ListItem = (props) => {
    const { settingSeqNo, setMemoTrgt, data, i } = props;
    // list 필요정보
    // 2020.10.21, 오후 2:30, 몸무게, bmi수치, 메모내역

    const openMemoBox = (i) => {
        $("#"+i).parent().toggleClass("on");
        $("#"+i).next(".inthe-box").slideToggle("fast");
    
        if ($("#"+i).parent().hasClass("on")) {
            var currentSctop = $("#"+i).parent().offset().top - 20;
            $("html, body").stop().animate({ scrollTop: currentSctop }, 400);
        }
    }

    return(
        <div>
            <div className="timebox">
                <label className="check-box">
                    <input type="checkbox" name="checkSeqNo" value={data.seqNo} onClick={()=>settingSeqNo()} /><i></i>
                    <span>{data.date1}<br/><em>{data.date2} {data.date3}</em></span>
                </label>
            </div>
            {/* z클릭시 on클래스 추가됨 */}
            <div 
                className=
                {data.bmi < 20 ? "infobox glmgrn"
                    :   (data.bmi >= 20 && data.bmi <= 25) ? "infobox smile"
                    :   (data.bmi > 25 && data.bmi <= 30) ? "infobox gloom2"
                    :   "infobox gloom3"
                }
            >
                <a className="btn-dropdown" onClick={(e)=>openMemoBox(i)} id={i}>
                    <i></i>
                    <div>
                        {data.wght} <em className="mn">kg</em>
                        <p>BMI <b>{data.bmi}kg/㎡</b></p>
                    </div>
                </a>
                
                {/* 안쪽 내용 */}
                <div className="inthe-box">
                    <span>
                        BMI {data.bmi}kg/㎡
                        {data.bmi < 20 && <em> · 정상이하</em>}
                        {data.bmi >= 20 && data.bmi <= 25 && <em> · 안정</em>}
                        {data.bmi > 25 && data.bmi <= 30 && <em> · 과체중</em>}
                        {data.bmi > 30 && data.bmi <= 35 && <em> · 비만</em>}
                        {data.bmi > 35 && <em> · 고도비만</em>}
                    </span>
                    <p>
                        {data.memo}
                    </p>
                    <div className="btn-right">
                        <a className="btn-memo" onClick={()=>setMemoTrgt(data.seqNo, data.memo)} ><i></i>메모</a>
                        {/* <a className="btn-memo" onClick={()=>setMemoTrgt(data.seqNo)} ><i></i>메모</a> */}
                    </div>
                </div>

            </div>
        </div>
    );
}

const MemoLayer = (props) => {
    const {userinfo, cfg, phonecfg} = useContext(AppContext);
    const {memoData, request1403} = props;

    useEffect(() => {
        $(".btn-memo").click(function(){
            openLayerFn($(".memo-layer"));
        });
        //메모 레이어 닫기(취소, 확인 모두)
        $(".memo-layer .tbns-area a").click(function(){
            closeLayerFn($(".memo-layer"));
        });
    }, []);

    const openMemoLayer = () => {

    }

    const request1409 = () => {
        PostApi1409(userinfo, cfg, phonecfg, memoData.seqNo, $("#bmiMemoTxt").val())
        .then(res => {
            if (res.resultMsg === 'SUCCESS') {
                // 화면새로고침
                request1403(userinfo);
                $("#bmiMemoTxt").val("");
            }
        })
        .catch(err => {
            console.log(err);
        });
    }

    return(
        <div className="blacklayer-container memo-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box vertical">
                        <div className="blgr-title">메모</div>
                        
                        <div className="inlayer-memo-area">
                            <textarea className="textarea-box" id="bmiMemoTxt" placeholder="메모를 입력해 주세요." maxLength="150"></textarea>
                        </div>

                        <div className="tbns-area">
                            <a className="btn-round gray">취소</a>
                            <a className="btn-round wht" onClick={()=>request1409()}>확인</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const TargetWeight = (props) => {
    const { userinfo, cfg, phonecfg } = useContext(AppContext);
    const { trgtValue, trgtValueHandler } = props;

    const request1405 = (trgtWght) => {
        let vrtnValue = "M";

        if($("#vrtnType").is(":checked")) {
            vrtnValue = "P"
        }

        PostApi1405(userinfo, cfg, phonecfg, trgtWght, vrtnValue)
        .then(res => {
            if(res.resultMsg === 'SUCCESS') {
                trgtValueHandler(trgtWght, vrtnValue);
                closeLayerFn($(".bloodgoal-layer"));
            } else if(res.resultMsg === 'LOGOUT') {
                // openAlertPopup("다른 기기에 로그인 되어있습니다.");
                openLayerFn($('.alert-layer-logout'));
                closeLayerFn($(".bloodgoal-layer"));
            } else {
                console.log("#### ERR: " + res.resultMsg);
                closeLayerFn($(".bloodgoal-layer"));
            }
        })
    }

    useEffect(() => {
        $(".btn-goalset, .open-target-weight").click(function() {
            openLayerFn($(".bloodgoal-layer"));
            userHabit(phonecfg, 'BM100_P01');
        });

        if(trgtValue.vrtnType == "P") {
            $("#vrtnType").attr("checked", true);
        }
    }, []);

    return(
        <div className="blacklayer-container bloodgoal-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box vertical">
                        <div className="blgr-title">목표 몸무게 설정</div>
                        <div className="under-txt">
                            담당 의사와 상담한 목표 몸무게 수치입니다.<br/>
                            (미 설정시 키에 따른 표준 몸무게를 목표 몸무게로 설정합니다.)
                        </div>

                        
                        <div className="target-setting-box">
                            <div className="inly-sutit">목표 몸무게</div>
                            <div className="inly-backword">
                                <i>kg</i>
                                {trgtValue &&
                                    <input type="number" pattern="\d*" maxLength="3" className="textbox bld" id="trgtWght" onInput={(e) => maxLengthCheck(3, e)} />
                                }
                            </div>
                            <div className="under-txt">
                                증량이 목표일 때 체크해 주세요
                                <input type="checkbox" id="vrtnType" style={{marginLeft:"10px", marginBottom:"3px"}} />
                                
                            </div>
                        </div>


                        <div className="tbns-area">
                            <a className="btn-round gray" onClick={()=>closeLayerFn($(".bloodgoal-layer"))}>취소</a>
                            <a className="btn-round wht" onClick={()=>request1405($("#trgtWght").val())}>확인</a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}